var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isReady,
          expression: "isReady",
        },
      ],
    },
    [
      _c(
        "select",
        {
          staticClass: "custom-select custom-select-lg country-select text-lg",
          on: { change: _vm.navigateToUrl },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }